const CMS_COMPONENT_SOURCE_TYPES = {
  CMS: 'cms',
  VOLTRAN: 'voltran',
}

export {
  CMS_COMPONENT_SOURCE_TYPES
}
